import SvgWithOutContent from "@public/svg/dataState/box-withOut-content.svg";
import ExploreWitoutContent from "@public/svg/dataState/explore-withOut-content.svg";
import SvgNoPlan from "@public/svg/dataState/no-plan.svg";
import SVG from "components/SVG";
import { ValueOf } from "next/dist/shared/lib/constants";
import React from "react";

export const SvgVariantType = {
  default: "default",
  boxWithOutContent: "box-withOut-content",
  exploreWithOutContent: "explore-withOut-content",
} as const;

type SvgWithOutDataProps = {
  readonly variant?: ValueOf<typeof SvgVariantType>;
  /**
   * @type string
   * @example
   * title={`${t("")}`}
   */
  readonly title?: string;
  /**
   * @type string
   * @example
   * description={`${t("")}`}
   */
  readonly description?: string;
  readonly content?: React.ReactNode;
};

/**
 *
 * @param props
 * @returns
 * @description
 * This component is used to show a svg with a title and a description
 * @example
 * <SvgWithOutData
 *  variant="box-withOut-content"
 *  title={`${t("hi this is a title")}`}
 *  description={`${t("Hi this is a description")}`}
 *  content={<p>Hi this is a content</p>}
 * />
 */
export default function SvgWithOutData(props: SvgWithOutDataProps) {
  const { variant = "default" } = props;
  const svgProps =
    variant === SvgVariantType.boxWithOutContent
      ? {
          src: SvgWithOutContent,
          width: SvgWithOutContent.width,
          height: SvgWithOutContent.height,
        }
      : variant === SvgVariantType.exploreWithOutContent
        ? {
            src: ExploreWitoutContent,
            width: ExploreWitoutContent.width,
            height: ExploreWitoutContent.height,
          }
        : { src: SvgNoPlan, width: SvgNoPlan.width, height: SvgNoPlan.height };

  return (
    <div className="grid w-full justify-items-center">
      <div className="mb-4">
        <SVG
          key={variant}
          src={svgProps.src}
          width={svgProps.width}
          height={svgProps.height}
        />
      </div>
      {props.title && (
        <h3 key={variant} className="mb-2 text-center text-xl font-semibold">
          {props.title}
        </h3>
      )}
      {props.description && (
        <p
          key={variant}
          className="text-left text-gray-600 dark:text-gray-200 md:text-center"
        >
          {props.description}
        </p>
      )}
      {props.content}
    </div>
  );
}
